import React, { useState } from 'react';
import { registerBrick } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import { getIcon } from '../shared/utils/_icons.jsx';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Checkbox from '@mui/material/Checkbox';
import { FormControlLabel } from '@mui/material';

export default class TopButtonMultiSelect extends ReactBrick {
    static getReactComponent($) {

        return (props) => {
            const topButtonStyle = {
                background: $.get('Background color'),
                borderColor: $.get('Main color'),
                color: $.get('Main color'),
            };

            const topButtonSelectedStyle = {
                background: $.get('Selected background color'),
                borderColor: $.get('Selected main color'),
                color: $.get('Main color'),
            };

            const items = useProperty($, 'Possible values')?.split(",") || [];
            const itemSelected = useProperty($, 'Selected item') || [];
            const listTitle = useProperty($, "List title");

            const [anchorEl, setAnchorEl] = useState(null);

            const [selectAll, setSelectAll] = useState(false);

            const handleClick = (event) => {
                setAnchorEl(event.currentTarget);
            };

            const handleClose = () => {
                setAnchorEl(null);
            };

            const handleOnChange = (isChecked, item) => {
                let updatedArr = [...itemSelected];

                // Checks every items select/unselect
                if (isChecked) {
                    if (itemSelected.indexOf(item) === -1) {
                        updatedArr.push(item);
                    }
                } else {
                    let index = itemSelected.indexOf(item);
                    if (index > -1) {
                        updatedArr.splice(index, 1);
                    }
                }

                // Checks select all and unselect all.
                if (updatedArr.length === items.length) {
                    !selectAll && setSelectAll(true);
                } else if (updatedArr.length === 0) {
                    selectAll && setSelectAll(false);
                }

                // Update the selected value and Triggers selected event
                $.set('Selected item', updatedArr);
                $.trigger("On item selected");
            }

            const handleToggleSelectAll = (isSelectAll) => {
                setSelectAll(isSelectAll);

                // Updating selected item based on selectAll value.
                $.set("Selected item", isSelectAll ? items : []);
                $.trigger("On item selected");
            }

            return (
                <div
                    className={itemSelected.length > 0 ? 'top-button-selected' : 'top-button'}
                    style={itemSelected.length > 0 ? topButtonSelectedStyle : topButtonStyle}
                >
                    <div className={'top-button-grid'}>
                        <div className={'top-button-grid-icon'}>
                            {getIcon($.get("MUI Icon"), true, { style: { fontFamily: 'inherit', fontSize: '1.2rem' } })}
                        </div>
                        <div className={'top-button-grid-title'}>{$.get("Title")}</div>
                        <div />
                        <div className={'top-button-grid-dropdown'} onClick={handleClick}>
                            <div className={'top-button-grid-list-title'}>
                                {itemSelected.length > 0 ? itemSelected.toString() : listTitle}
                            </div>
                            {getIcon('KeyboardArrowDown', true, { style: { fontSize: '14px' } })}
                        </div>
                        <div className={'dropdown'}>
                            <Menu
                                id="simple-menu"
                                color="primary"
                                anchorEl={anchorEl}
                                keepMounted
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                <FormControlLabel
                                    label={itemSelected.length === items.length ? "Unselect All" : "Select All"}
                                    control={<Checkbox
                                        checked={selectAll}
                                        indeterminate={itemSelected.length > 0 && itemSelected.length !== items.length}
                                        onChange={(e) => {
                                            handleToggleSelectAll(e.target.checked);
                                        }}
                                        name="gilad" />}
                                    style={{ paddingLeft: "10px", paddingTop: '5px' }}
                                >
                                </FormControlLabel>
                                {items?.map((item) => {
                                    return (
                                        <MenuItem
                                            key={'MenuItem' + $.get("Title") + item}
                                            onMouseEnter={(e) => e.target.style.backgroundColor = props.mainColor + '44'}
                                            onMouseLeave={(e) => e.target.style.backgroundColor = '#00000000'}
                                        >
                                            <FormControlLabel
                                                label={item}
                                                style={{ paddingLeft: '25px', margin: '-8px' }}
                                                control={<Checkbox
                                                    edge="start"
                                                    checked={itemSelected?.indexOf(item) !== -1}
                                                    tabIndex={-1}
                                                    disableRipple
                                                    onChange={(e) => {
                                                        handleOnChange(e.target.checked, item);
                                                    }}
                                                />}>
                                            </FormControlLabel>
                                        </MenuItem>
                                    );
                                })}
                            </Menu>
                        </div>
                    </div>
                </div>
            );
        };
    }
}

registerBrick('0190beb7bc037691d427', TopButtonMultiSelect);
